import React from 'react';
import { render } from 'react-dom'
import BlankDatePicker from './DatePicker'
import styles from '!style-loader/useable!css-loader!react-bootstrap-daterangepicker/css/daterangepicker.css'

const DateRange = Object.create(HTMLElement.prototype)

DateRange.createdCallback = function createdCallback() {
  // console.warn('DateRange#createdCallback')
  styles.use()
}

DateRange.attachedCallback = function attachedCallback() {
  // console.warn('DateRange#attachedCallback - with Picker')

  const props = {}
  const raw = this.getAttribute('value')

  if (raw) {
    const [start, end] = raw.split(' - ')
    props.start = start
    if (end) props.end = end
  }

  if (this.hasAttribute('id')) props.id = this.getAttribute('id')
  if (this.hasAttribute('name')) props.name = this.getAttribute('name')

  render(<BlankDatePicker {...props} />, this)
}

DateRange.detachedCallback = function detachedCallback() {
  // console.warn('DateRange#detachedCallback')
  styles.unuse()
}

export default DateRange;



// WEBPACK FOOTER //
// ./src/elements/date-range/index.js